import { render, staticRenderFns } from "./MealBreakPendingApproval.vue?vue&type=template&id=2cb31708&"
import script from "./MealBreakPendingApproval.vue?vue&type=script&lang=js&"
export * from "./MealBreakPendingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports